import type { StatsType } from '@/types/stats.types'

import { CHART_COLORS } from '@/constants/chartColors.constants'

import type { StatsCounter } from '@/__generated__/requests'

export const getStats = (data?: StatsCounter): StatsType =>
  Object.entries(data?.stats || {})
    .filter((entry): entry is [string, number] => typeof entry[1] === 'number')
    .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {})

export const getTotal = (stats: StatsType): number =>
  Object.values(stats).reduce((sum, value) => sum + value, 0)

export const getGenderSections = (stats: StatsType, total: number) =>
  Object.keys(stats).map((key, index) => ({
    color: CHART_COLORS[index],
    initialValue: stats[key],
    label: key,
    value: total ? (stats[key] / total) * 100 : 0,
  }))

export const getDonutSections = (stats: StatsType) =>
  Object.keys(stats).map((key, index) => ({
    color: CHART_COLORS[index],
    name: key,
    value: stats[key],
  }))
